import { supabase } from "@supabaseClient/supabaseClient";
import type { Plan, Subscription } from "../types";

export const billingClient = {
  /** The org's subscription row, or null if billing has never been started. */
  getSubscription: async (orgId: string): Promise<Subscription | null> => {
    const { data } = await supabase
      .from("subscriptions")
      .select("*")
      .eq("organization_id", orgId)
      .maybeSingle()
      .throwOnError();
    return (data as Subscription | null) ?? null;
  },

  /** Plan/price display details from Stripe. Defaults to the org's plan. */
  getPlan: async (priceId?: string): Promise<Plan> => {
    const { data, error } = await supabase.functions.invoke<Plan>("get-plan", {
      body: priceId ? { priceId } : {},
    });
    if (error) throw error;
    if (!data) throw new Error("No plan returned");
    return data;
  },

  /** Returns a Stripe Checkout URL to redirect the user to. */
  createCheckoutSession: async (): Promise<string> => {
    const { data, error } = await supabase.functions.invoke<{ url: string }>(
      "create-checkout-session",
      { body: {} },
    );
    if (error) throw error;
    if (!data?.url) throw new Error("No checkout URL returned");
    return data.url;
  },

  /** Returns a Stripe Customer Portal URL to redirect the user to. */
  createPortalSession: async (): Promise<string> => {
    const { data, error } = await supabase.functions.invoke<{ url: string }>(
      "create-portal-session",
      { body: {} },
    );
    if (error) throw error;
    if (!data?.url) throw new Error("No portal URL returned");
    return data.url;
  },
};
